import { useCallback } from "react";
import { Container } from "./styled";
import { calculatePlayerStats } from "../../lib/cabbStats";

export default function PlayerStatsResume({
  activeProfile,
  activeGames,
  previousSeasonGameses,
  isDnD,
  players,
  setActiveProfile,
}) {
  const getArrowDirection = useCallback(
    (statName) => {
      // Only calculate if we have data
      if (!previousSeasonGameses || previousSeasonGameses.length === 0) {
        return "";
      }
      const previousStat =
        calculatePlayerStats(
          previousSeasonGameses,
          activeProfile?._id,
          statName
        ) || 0;
      const currentStat =
        calculatePlayerStats(activeGames, activeProfile?._id, statName) || 0;

      return previousStat > currentStat ? "down-arrow" : "up-arrow";
    },
    [previousSeasonGameses, activeGames, activeProfile?._id]
  );

  const calculatePreviusSeasonStats = (stat) => {
    return calculatePlayerStats(
      previousSeasonGameses,
      activeProfile?._id,
      stat
    );
  };

  return (
    <Container isDnD={isDnD}>
      {isDnD ? (
        <select
          onChange={(e) => {
            setActiveProfile(e.target.value);
          }}
        >
          <option value="">Selecciona jugador</option>
          {players !== null &&
            players !== undefined &&
            players
              .filter((player) => player.active_team !== "undefined")
              .sort((a, b) => {
                const fullNameA = `${a.player_name
                  ?.toUpperCase()
                  .trimStart()} ${a.player_lastname
                  ?.toUpperCase()
                  .trimStart()}`;
                const fullNameB = `${b.player_name
                  ?.toUpperCase()
                  .trimStart()} ${b.player_lastname
                  ?.toUpperCase()
                  .trimStart()}`;
                return fullNameA.localeCompare(fullNameB);
              })
              .map((player, index) => (
                <option value={player._id}>
                  {`${player.player_name
                    ?.toUpperCase()
                    .trimStart()} ${player.player_lastname
                    ?.toUpperCase()
                    .trimStart()}`}
                </option>
              ))}
        </select>
      ) : null}
      <h2>
        {activeProfile?.player_name} {activeProfile?.player_lastname}
      </h2>
      <div className="personal-stats">
        <div className="personal-stats-element">
          <p className={getArrowDirection("MINSP")}>MPP</p>
          <p className="stat-value">
            {calculatePlayerStats(activeGames, activeProfile?._id, "MINSP")}
          </p>
        </div>
        <div className="personal-stats-element">
          <p
            className={
              (calculatePreviusSeasonStats("eFG") || 0) >
              (calculatePlayerStats(activeGames, activeProfile?._id, "eFG") ||
                0)
                ? "down-arrow"
                : "up-arrow"
            }
          >
            %efg
          </p>
          <p className="stat-value">
            {calculatePlayerStats(activeGames, activeProfile?._id, "eFG")}
          </p>
        </div>
        <div className="personal-stats-element">
          <p
            className={
              calculatePreviusSeasonStats("OREB") >
              calculatePlayerStats(activeGames, activeProfile?._id, "OREB")
                ? "down-arrow"
                : "up-arrow"
            }
          >
            %OREB
          </p>
          <p className="stat-value">
            {calculatePlayerStats(activeGames, activeProfile?._id, "OREB")}
          </p>
        </div>
        <div className="personal-stats-element">
          <p
            className={
              calculatePreviusSeasonStats("FTR") >
              calculatePlayerStats(activeGames, activeProfile?._id, "FTR")
                ? "down-arrow"
                : "up-arrow"
            }
          >
            %FTR
          </p>
          <p className="stat-value">
            {calculatePlayerStats(activeGames, activeProfile?._id, "FTR")}
          </p>
        </div>
        <div className="personal-stats-element">
          <p
            className={
              calculatePreviusSeasonStats("TOR") >
              calculatePlayerStats(activeGames, activeProfile?._id, "TOR")
                ? "down-arrow"
                : "up-arrow"
            }
          >
            %TOR
          </p>
          <p className="stat-value">
            {calculatePlayerStats(
              activeGames,
              activeProfile?._id,
              "TOR"
            ).toFixed(1)}
          </p>
        </div>
      </div>
      <div className="secondary-personal-container">
        <div>
          <p>Mins totales</p>
          <h2>
            {Math.round(
              calculatePlayerStats(activeGames, activeProfile?._id, "MINS")
            )}
          </h2>
        </div>
        <div>
          <p>Partidos</p>
          <h2>
            {calculatePlayerStats(activeGames, activeProfile?._id, "GAMES")}
          </h2>
        </div>
      </div>
    </Container>
  );
}
